/**
 * Feature flags for the Originator redesign.
 *
 * Category C items from docs/originator-preservation-strategy.md depend on
 * backend fields/endpoints that do not exist yet. Each flag below stays `false`
 * until the additive, backward-compatible backend support lands. The UI must
 * read these flags and degrade gracefully (hide the control, never fabricate
 * data) when a flag is off.
 *
 * Flip a flag to `true` only after the corresponding optional field/endpoint is
 * available — no existing API contract changes are required to do so.
 */
export const FEATURES = {
  /** C1 — "Items in AI Review" KPI + IDA review queue. */
  aiReview: false,
  /** C2 — KPI trend deltas (arrows + % change). */
  kpiTrends: false,
  /** C3 — Evidence completeness % bars on lists/detail. */
  evidenceProgress: false,
  /** C4 — Source channel (SFTP/Webhook/API/Manual/Polling) on rows. */
  sourceChannel: false,
  /** C5 — "Claimed by you / Waiting" ownership. */
  claimOwnership: false,
  /** C6 — Exception type taxonomy + age + resolved metrics. */
  exceptionTypes: false,
  /** C7 — Bulk operations (bulk solve / bulk select). */
  bulkActions: false,
  /** C8 — Stage progress timeline on list rows. */
  stageProgress: false,
  /** C9 — Exports (CSV/PDF) for list screens. */
  listExports: false,
  /** C12 — Per-state count KPIs (needs a list-summary endpoint). */
  packageStateCounts: false,
  /**
   * Real auth UI (email/password + workspace picker).
   * On when REACT_APP_AUTH_MODE is jwt or dual.
   */
  realAuth:
    process.env.REACT_APP_AUTH_MODE === 'jwt' ||
    process.env.REACT_APP_AUTH_MODE === 'dual',
  /**
   * Microsoft Entra SSO button. On when the SPA client and tenant are set.
   */
  entraSso:
    process.env.REACT_APP_ENTRA_ENABLED !== 'false' &&
    Boolean(
      process.env.REACT_APP_ENTRA_CLIENT_ID && process.env.REACT_APP_ENTRA_TENANT_ID
    ),
  /**
   * Labelled view/download renditions. Ordinary access must not return
   * preserved original bytes. APIs live under /rendition and /copy-contexts.
   */
  labelledCopies: true,
  /**
   * Provider Admin Console (Organization setup first).
   * Default off until product sign-off. Enable with REACT_APP_PROVIDER_ADMIN_CONSOLE=true.
   */
  providerAdminConsole: process.env.REACT_APP_PROVIDER_ADMIN_CONSOLE === 'true',
};
